import { createAction } from '../util/actionHelper.js';

export const selectStatusButton = createAction(
  'STATUS_BUTTON_SELECT',
  statusButtonVal => statusButtonVal
);
